import { QueryClient, QueryClientProvider } from "react-query";

const queryClientSettings = {
	defaultOptions: {
		queries: {
			staleTime: 1 * (60 * 5000), // 5 min
			cacheTime: 10 * (60 * 1000), // 10 mins
			retryDelay: 5 * 1000, // 5 sec
			//	maxRetries: 1,
			retry: false,
		},
	},
};

export const lifetimeDataQuerySetting = {
	staleTime: 24 * 60 * (60 * 1000), // 1 day
	cacheTime: 24 * 60 * (60 * 1000), // 1 day
	refetchOnWindowFocus: false,
};

export const CustomQueryClientProvider = ({ children }: { children: any }) => {
	const queryClient = new QueryClient(queryClientSettings);

	return (
		<QueryClientProvider client={queryClient}>
			{children}
		</QueryClientProvider>
	);
};
